import { withDependencies } from '@wix/thunderbolt-ioc'
import type { IAppWillLoadPageHandler, LivePreviewOptions, PlatformEnvDataProvider } from '@wix/thunderbolt-symbols'
import type { LivePreviewEnvDataSetter } from '../types'
import { INavigationManager, NavigationManagerSymbol } from 'feature-navigation-manager'

export const livePreviewEnvDataProvider = withDependencies([NavigationManagerSymbol], (navigationManager: INavigationManager): PlatformEnvDataProvider &
	LivePreviewEnvDataSetter &
	IAppWillLoadPageHandler => {
	let livePreviewEnvData: Partial<LivePreviewOptions> = {}
	return {
		name: 'livePreviewEnvDataProvider',
		platformEnvData() {
			return {
				livePreviewOptions: navigationManager.isDuringNavigation() ? {} : livePreviewEnvData,
			}
		},
		set(livePreviewOptions) {
			livePreviewEnvData = livePreviewOptions
		},
		appWillLoadPage() {
			livePreviewEnvData = {}
		},
	}
})
